export const types = {
    YEAR_TYPE: 'year',
    QUARTER_TYPE: 'quarter',
}

export const PAYMENT_INDEX_CHART_TOGGLE_SELECTOR = 'PAYMENT_INDEX_CHART_TOGGLE_SELECTOR'
export const PAYMENT_INDEX_CHART_TOGGLE_DATA_TABLE = 'PAYMENT_INDEX_CHART_TOGGLE_DATA_TABLE'
export const PAYMENT_INDEX_TOGGLE_TERMINOLOGY = 'PAYMENT_INDEX_TOGGLE_TERMINOLOGY'
